import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-img-table',
  templateUrl: './img-table.component.html',
  styleUrls: ['./img-table.component.scss']
})
export class ImgTableComponent implements OnInit {

  constructor() { }
  public params: any;

  agInit(params: any): void {
    this.params = params;
  }
  ngOnInit() {
  }

}
